// extracted by mini-css-extract-plugin
export var smallSpinner = "_xo-0";